import { DaycareReleaseParameters, ReleaseActivation } from '@/types/Daycare.ts'
import moment, { Moment } from 'moment/moment'

export function calculateScheduleDateWithReleaseParameters(
    date: string,
    releaseParameters?: DaycareReleaseParameters
): string | undefined {
    if (!releaseParameters) return ''

    if (releaseParameters.releaseActivation === ReleaseActivation.releaseDay) {
        const day: number = releaseParameters.releaseDayCountBefore
        const hour: string = moment(releaseParameters.releaseHour, 'HH:mm:ss').format('HH:mm')
        const res: string = moment(date, 'DD-MM-YYYY HH:mm').subtract(day, 'days').format('DD-MM-YYYY') + ' ' + hour

        return moment(res, 'DD-MM-YYYY HH:mm').isBefore(moment()) ? undefined : res
    } else if (releaseParameters.releaseActivation === ReleaseActivation.releaseWeek) {
        const slotDate: Moment = moment(date, 'DD-MM-YYYY HH:mm')
        const week: number = releaseParameters.releaseWeekCountBefore
        const hour: string = moment(releaseParameters.releaseHour, 'HH:mm:ss').format('HH:mm')
        const day: number = releaseParameters.releaseDay

        const res: string =
            slotDate
                .clone()
                .subtract(1, 'day')
                .subtract(week, 'weeks')
                .day(day === 6 ? 0 : day + 1)
                .format('DD-MM-YYYY') +
            ' ' +
            hour

        return moment(res, 'DD-MM-YYYY HH:mm').isBefore(moment()) ||
            moment(res, 'DD-MM-YYYY HH:mm').isSameOrAfter(slotDate, 'day')
            ? undefined
            : res
    } else {
        return undefined
    }
}
